import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import EditLicenseDialog from "./EditLicenseDialog";
import BindHardwareDialog from "../Hardwares/BindHardwareDialog";
import ViewLicenseDetials from "./ViewLicenseDetails";
import ConfirmationDialog from "../common/ConfirmationDialog";
import LicenseList from "./LicensesList";
import { licensesActions } from "../../store/licenses-slice";
import { deleteLicense } from "../../store/licenses-actions";
import { ROLES } from "../../store/auth-slice";

const LicensesDashboard = (props) => {
  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isBinding, setIsBinding] = useState(false);
  const [isRemove, setIsRemove] = useState(false);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  const selectedLicense = useSelector(
    (state) => state.licenses.selectedLicense
  );
  const role = useSelector((state) => state.auth.authUser.role);
  const isCustomer = role === ROLES.ROLE_CUSTOMER;

  const licenses = useSelector((state) => state.licenses.list);
  const dispatch = useDispatch();

  let selectedLicenseId = null;
  if (selectedLicense) {
    selectedLicenseId = selectedLicense.id;
  }

  const { customerId } = props;

  const rowSelectedHandler = (event) =>
    dispatch(licensesActions.setSelectedLicense(event.data.id));

  const closeBindDialogHandler = () => setIsBinding(false);

  const addLicenseHandler = () => setIsAdding(true);
  const editLicenseHandler = () => setIsEditing(true);

  const deleteLicenseHandler = async () => {
    dispatch(deleteLicense(selectedLicense));
    setIsRemove(false);
  };

  const closeEditDialogHandler = () => {
    if (isEditing) {
      setIsEditing(false);
    }
    if (isAdding) {
      setIsAdding(false);
    }
  };

  const blockLicenseHandler = () =>
    dispatch(licensesActions.blockLicense(selectedLicenseId));

  const isEditWindowMounted = isAdding || isEditing;

  return (
    <>
      {isEditWindowMounted && (
        <EditLicenseDialog
          customerId={customerId}
          licenseId={selectedLicenseId}
          isAdding={isAdding}
          open={isEditing || isAdding}
          onClose={closeEditDialogHandler}
        />
      )}
      <ConfirmationDialog
        open={isRemove}
        onClose={() => setIsRemove(false)}
        onOk={() => deleteLicenseHandler()}
        caption="Please confirm?"
        text="This will delete this license completely. Are You sure?"
      />
      <ViewLicenseDetials
        open={isDetailsOpen}
        licenseId={selectedLicenseId}
        onClose={() => setIsDetailsOpen(false)}
      />
      <LicenseList
        basic={isCustomer}
        mode={props.mode}
        licenses={licenses}
        density={props.density ? props.density : "compact"}
        height={props.height}
        loading={props.loading}
        onRowSelected={rowSelectedHandler}
        onAdd={addLicenseHandler}
        isAddDisabled={customerId === undefined}
        onEdit={editLicenseHandler}
        isEditDisabled={
          selectedLicense == null || selectedLicense.state === "Assigned"
        }
        onDelete={() => setIsRemove(true)}
        isDeleteDisabled={selectedLicense == null}
        onLink={() => setIsBinding(true)}
        isLinkDisabled={selectedLicense == null}
        onView={() => setIsDetailsOpen(true)}
        isViewDisabled={
          selectedLicense == null || selectedLicense.state === "Free"
        }
        onBlock={blockLicenseHandler}
        isBlockDisabled={
          selectedLicense == null || selectedLicense.state === "Canceled"
        }
      />
      {selectedLicense && isBinding && (
        <BindHardwareDialog
          id="hardwareId-menu"
          licenseId={selectedLicenseId}
          open={isBinding}
          onClose={closeBindDialogHandler}
        />
      )}
    </>
  );
};

export default LicensesDashboard;
